import { TFileType } from "../models";
import { IChannel } from "../models/channel";

export const findChannelById = (
  channeList: IChannel[],
  channelId: string
): IChannel | undefined => {
  const splittedId = channelId.split("+");

  // No subChannel
  if (splittedId.length === 1) {
    return channeList.find((c) => c.id.toString() === channelId);
  }

  // Sub Channel - Nested Level 1
  if (splittedId.length === 2) {
    const parentsId = splittedId[0];
    const subChannelId = splittedId[1];
    return channeList
      .find((c) => c.id.toString() === parentsId)
      ?.subChannels?.find((c) => c.id.toString() === subChannelId);
  }

  const superId = splittedId.shift();
  const parentChannels = channeList.find((c) => c.id.toString() === superId)
    ?.subChannels!;

  // remove parentId
  return findChannelById(parentChannels, splittedId.join("+"));
};

/**
 *  PATERN WILL BE LIKE
 * Know Your Rights/assets/videos/sixsimplerules.mp4
 * **/

export const getCardTypeFromPath = (path: string): TFileType => {
  const pathArr = path.split("/");

  if (!pathArr.length) {
    return "channel";
  }

  return pathArr.includes("videos") ? "video" : "image";
};

const getChannelName = (id: string, channels: IChannel[]) => {
  return channels.find((c) => c.id.toString() === id);
};

export const generateChannelPathById = (
  channelId: string,
  rootChannels: IChannel[]
) => {
  let path: string[] = [];
  let currentChannels: IChannel[] = rootChannels;

  const splittedIds = channelId.split("+");

  splittedIds.forEach((id) => {
    const foundChannel = getChannelName(id, currentChannels);

    if (foundChannel) {
      path.push(foundChannel.title);
    }

    if (foundChannel?.subChannels) {
      currentChannels = foundChannel.subChannels;
      return;
    }
  });

  return path;
};
